import { PureComponent } from 'react';
import { Link } from 'react-router-dom';

import Input from '../components/input/input';

class SignIn extends PureComponent {
  state = {
    email: '',
    password: '',
    isValid: true,
  };

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  async onSubmit() {
    const { email, password } = this.state;

    if (this.isValid()) {
      this.props.onSignIn({ data: { email, password } });
    } else {
      this.setState({ isValid: this.isValid() });
      window.scrollTo(0, 0);
    }
  }

  onKeyDown = (e) => {
    if (e.key === 'Enter') this.onSubmit();
  };

  isValid() {
    const { email, password } = this.state;
    return email !== '' && password !== '';
  }

  render() {
    const { errors } = this.props;
    const { email, password, isValid } = this.state;

    const messageBox = errors && (
      <div className="errors">
        {errors &&
          errors.map((error, index) => (
            <span key={index}>{error.message}</span>
          ))}
      </div>
    );

    return (
      <main className="th-main">
        <section className="th-canvas">
          <header className="th-canvas-header"></header>
          <div>
            <div className="auth">
              <div className="header">
                <h1>Sign In</h1>
              </div>
              {messageBox}
              <div className="w-100 flex flex-column items-start justify-between mt10">
                <div className="w-100">
                  <Input
                    name="email"
                    label="Email*"
                    value={email}
                    valid={isValid || email !== ''}
                    onChange={(event) => this.onChange(event)}
                  />
                </div>
                <div className="w-100">
                  <Input
                    name="password"
                    type="password"
                    label="Password*"
                    value={password}
                    valid={isValid || password !== ''}
                    onChange={(event) => this.onChange(event)}
                    onKeyDown={this.onKeyDown}
                  />
                </div>
              </div>
              <Link className="fr" to="/forgot_password">
                Forgot your password?
              </Link>
              <div className="action">
                <button
                  className="btn-green"
                  data-cy="submit"
                  onClick={() => this.onSubmit()}
                >
                  Sign in
                </button>
              </div>
            </div>
          </div>
        </section>
      </main>
    );
  }
}

export default SignIn;
